import * as React from 'react';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { ToolbarConfig, MenuConfig } from '@tencent/workbench';
import { TOOLBAR_FORMAT_TRANSFORM } from '@src/framework/editor/src/img/pageIndex';
import { wrapIdForBig } from '../../util/wrap-id-util';
import { MenuDescriptionIcon } from '@framework/workbench/common/components/menu-description-icon';
import VIP_ICON from '@tencent/docs-design-resources/icon/mobile/svg/vip_minitag_12.svg';

export const config = {
    id: ActionType.PDF_TRANSFORM,
    content: i18n.t('PDF转换'),
    tipMsg: i18n.t('PDF转换'),
    icon: TOOLBAR_FORMAT_TRANSFORM,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        hasArrow: true,
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''}/>,
        text: config.content,
        style: {
            width: 'auto',
        },
    },
    {
        name: wrapIdForBig(config.id),
        hasArrow: true,
        text: config.content,
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''}/>,
        style: {
            width: 'auto',
        },
    },
    {
        name: wrapIdForBig(`${ActionType.PDF_TRANSFORM}-parent`),
        hasArrow: true,
        text: i18n.t('格式转换'),
        tooltip: i18n.t('格式转换'),
        icon: <img src={config.icon} alt={''}/>,
        style: {
            width: 'auto',
        },
    },
    {
        name: `${ActionType.PDF_TRANSFORM}-parent`,
        hasArrow: true,
        tooltip: i18n.t('格式转换'),
        icon: <img src={config.icon} alt={''}/>,
        text: i18n.t('格式转换'),
        style: {
            width: 'auto',
        },
    },

];

export const EXPORT_PDF_CONFIG: MenuConfig = {
    name: `${ActionType.EXPORT_PDF}-toolbar`,
    content: i18n.t<string>('幻灯片转PDF'),
    tooltip: i18n.t<string>('幻灯片转PDF'),
};

export const PDF_TO_WORD_CONFIG: MenuConfig = {
    name: ActionType.PDF_TO_WORD,
    content: i18n.t<string>('PDF转Word（.docx）'),
    description: <MenuDescriptionIcon iconSrc={VIP_ICON} />,
};

export const PDF_TO_EXCEL_CONFIG: MenuConfig = {
    name: ActionType.PDF_TO_EXCEL,
    content: i18n.t<string>('PDF转Excel（.xlsx）'),
    description: <MenuDescriptionIcon iconSrc={VIP_ICON} />,
};

export const PDF_TO_PPT_CONFIG: MenuConfig = {
    name: ActionType.PDF_TO_PPT,
    content: i18n.t<string>('PDF转PPT（.pptx）'),
    description: <MenuDescriptionIcon iconSrc={VIP_ICON} />,
};

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
    },
    EXPORT_PDF_CONFIG,
    PDF_TO_WORD_CONFIG,
    PDF_TO_EXCEL_CONFIG,
    PDF_TO_PPT_CONFIG,
];
